import React, { useState } from "react";
import { SideMenu } from "./../../components";
import { Button } from "@mui/material";
import "./time-table.css";
import SchoolStructure from "./school-structure";
import Teachers from "./teachers";
import Schedule from "./schedule";
import ProductivityReport from "./productivity-report";
let TimeTable = () => {
  let [activeTab, setActiveTab] = useState("School Structure");
  let TableTabs = [
    {
      title: "School Structure",
    },
    {
      title: "Teachers",
    },
    {
      title: "Schedule",
    },
    {
      title: "Productivity Report",
    },
  ];
  return (
    <SideMenu>
      <div className="page-container">
        <div className="time-table-tags-main">
          {TableTabs.map((tagsValue, tagsIndex) => {
            return (
              <Button
                className={
                  activeTab === tagsValue.title
                    ? "time-table-selected-tag"
                    : "time-table-un-selected-tags"
                }
                variant="text"
                key={tagsIndex}
                onClick={() => setActiveTab(tagsValue.title)}
              >
                {tagsValue.title}
              </Button>
            );
          })}
        </div>
        <br />
        {activeTab === "School Structure" && <SchoolStructure />}
        {activeTab === "Teachers" && <Teachers />}
        {activeTab === "Schedule" && <Schedule />}
        {activeTab === "Productivity Report" && <ProductivityReport />}
      </div>
    </SideMenu>
  );
};
export default TimeTable;
